import { render } from "./PostItem.vue?vue&type=template&id=2281446e"
import script from "./PostItem.vue?vue&type=script&lang=js"
export * from "./PostItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__